var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01HireLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 339.67 119.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0H89.45a30,30,0,0,1,30,30v75.39a14.06,14.06,0,0,1-14.06,14.06H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.51,60.87c0-12.63,6.24-25.26,20.27-25.26S64,48.24,64,60.87,57.73,86.2,43.78,86.2,23.51,73.5,23.51,60.87Zm29.89,0c0-9-2.65-16-9.62-16s-9.69,7-9.69,16S36.73,77,43.78,77,53.4,69.9,53.4,60.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.44,85.32V49.78l-8.15,8.3-5.94-6.24,15.41-15.5h9.11v49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,85.32V64.76H157V85.32H146.57v-49H157V55.58h23.12V36.34h10.5v49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72,85.32v-49h10.43v49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,85.32l-9.62-17.4h-7.63v17.4H245.32v-49h22.91c10.21,0,16.45,6.69,16.45,15.79,0,8.66-5.44,13.29-10.72,14.54l11,18.65Zm1-33.19c0-4.11-3.16-6.61-7.34-6.61H255.75V58.74h10.94C270.87,58.74,274,56.24,274,52.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,85.32v-49h34.66v9.18H315.44V55.87h23.72v9.18H315.44V76.14h24.23v9.18Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01HireLogo);
export default __webpack_public_path__ + "static/media/01hire-logo.da3d097ad761d9af35c8d53885bd1fbe.svg";
export { ForwardRef as ReactComponent };